import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import * as S from '../landing.style';
import CompareTable from './CompareTable';
import TotalAnalysis from './TotalAnalysis';
import DetailAnalysis from './DetailAnalysis';
import OtherService from '../OtherService';
import { PageContainer } from '../../components/common/PageComponent.style';
import PageTop from '../../components/pageTop/PageTop';
import Footer from '../../components/footer/Footer';

function AlgorithmGuide() {
  const navigate = useNavigate();
  return (
    <PageContainer>
      <S.Container>
        <PageTop text="나만의 알고리즘" hasSearch={false} />
        <HeroSection>
          <S.HeroTitleWrapper>
            <S.BadgeContainer>
              <S.MembershipBadgeStandard>
                <span>Standard</span>
              </S.MembershipBadgeStandard>
              <S.MembershipBadgePremium>
                <span>Premium</span>
              </S.MembershipBadgePremium>
            </S.BadgeContainer>
            <HeroTitle>
              남들과는 다른
              <br />
              나만의 빅데이터 투자전략
            </HeroTitle>
          </S.HeroTitleWrapper>
          <HeroDescription>
            나만의 알고리즘으로 투자 전략을 직접 설계하고 검증해 <br />
            차별화된 투자 기회를 찾아보세요
          </HeroDescription>
        </HeroSection>

        <IntroSection>
          <IntroSectionTextArea>
            <S.SectionTitle>
              초개인화된 투자전략, 나만의 알고리즘
            </S.SectionTitle>
            <S.SectionDescription>
              모두가 같은 데이터를 보고 입찰하면 결과도 비슷할 수 밖에 없습니다.
              나만의 알고리즘은 내가 정한 조건을 반영해 나만의 투자 전략을
              세우고, 데이터로 검증된 수익성을 확인하도록 지원합니다.
            </S.SectionDescription>
          </IntroSectionTextArea>
          <IntroSectionImgWrapper>
            <img src="/assets/images/guide-landing/algo/intro_pc.png" alt="" />
          </IntroSectionImgWrapper>
        </IntroSection>

        <S.Section $background="#F0F4FA">
          <CompareSectionTitleWrapper>
            <S.SectionTitle $center>
              나만의 알고리즘과 퀀트분석,
              <br />
              어떻게 다른가요?
            </S.SectionTitle>
          </CompareSectionTitleWrapper>
          <CompareTable />
        </S.Section>

        <S.Section>
          <UsingGuideTitleSeciton>
            <S.UsingGuideSectionTitle>
              나만의 알고리즘 이용방법
            </S.UsingGuideSectionTitle>
            <S.UsingGuideSectionDescription>
              남들과 다른 투자전략으로
              <br />
              나만을 위한 부동산 경매 시작해보세요
            </S.UsingGuideSectionDescription>
          </UsingGuideTitleSeciton>
          <UsingGuide>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <img
                  src="/assets/images/guide-landing/algo/process_1_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingCardContent>
                <S.UsingGuideTitle>먼저 체험해보세요</S.UsingGuideTitle>
                <S.UsingGuideDesc>
                  나만의 알고리즘이 처음이라면 땅집고옥션에서 제공하는
                  알고리즘으로 먼저 체험해보세요
                </S.UsingGuideDesc>
              </UsingCardContent>
            </UsingGuideCard>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <img
                  src="/assets/images/guide-landing/algo/process_2_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingCardContent>
                <S.UsingGuideTitle>나만의 알고리즘 만들기</S.UsingGuideTitle>
                <S.UsingGuideDesc>
                  나만의 투자전략을 직접 설계해보세요. 매매부터 개발까지 상세한
                  조건을 직접 선택하도록 지원합니다.
                </S.UsingGuideDesc>
              </UsingCardContent>
            </UsingGuideCard>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <img
                  src="/assets/images/guide-landing/algo/process_3_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingCardContent>
                <S.UsingGuideTitle>알고리즘 수익성 분석</S.UsingGuideTitle>
                <S.UsingGuideDesc>
                  나의 전략은 안전할까? 수익성은 얼마나 될까? 알고리즘 수익성
                  분석으로 확인해보세요
                </S.UsingGuideDesc>
              </UsingCardContent>
            </UsingGuideCard>
            <UsingGuideCard>
              <UsingGuideImgBox>
                <img
                  src="/assets/images/guide-landing/algo/process_4_mobile.png"
                  alt=""
                />
              </UsingGuideImgBox>
              <UsingCardContent>
                <S.UsingGuideTitle>나만의 전략 저장소</S.UsingGuideTitle>
                <S.UsingGuideDesc>
                  잘 만들어둔 알고리즘은 저장해두세요. 새로운 경매 물건이
                  업데이트되면 나만의 전략으로 다시 사용할 수 있습니다.
                </S.UsingGuideDesc>
              </UsingCardContent>
            </UsingGuideCard>
          </UsingGuide>
        </S.Section>
        <S.ImgSection $bg="#1E3549">
          <S.CtaTitle>
            나만의 투자전략으로
            <br />
            경매 물건 찾아보세요
          </S.CtaTitle>
          <CtaButton onClick={() => navigate('/AiRecommendation')}>
            알고리즘 추천물건 바로가기
          </CtaButton>
        </S.ImgSection>

        <SampleSection>
          <SampleTitleSection>
            <SampleText>샘플 분석</SampleText>
            <S.SectionTitle>
              알고리즘 분석은
              <br />
              이렇게 구성되어 있습니다
            </S.SectionTitle>
          </SampleTitleSection>
          <Sample>
            <TotalAnalysis />
            <DetailAnalysis />
          </Sample>
        </SampleSection>
        <OtherService page="algorithm" />
        <Footer />
      </S.Container>
    </PageContainer>
  );
}

export default AlgorithmGuide;

const HeroSection = styled.div`
  display: flex;
  padding: 40px 24px;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  background-image: url('/assets/images/guide-landing/algo/hero_bg_mobile.png');
  background-size: cover;
  background-position: center;
`;

const HeroTitle = styled.div`
  color: #000000;
  font-size: 28px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.56px;
`;

const HeroDescription = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const IntroSection = styled(S.Section)`
  padding: 40px 16px;
`;

const IntroSectionTextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const IntroSectionImgWrapper = styled.div`
  display: flex;
  /* padding: 16px 0; */
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 24px;
  background: #1e3549;

  & > img {
    width: 100%;
  }
`;

const CompareSectionTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const UsingGuideTitleSeciton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const UsingGuide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const UsingGuideCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const UsingGuideImgBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 20px;
  background: #e7f0fe;

  & > img {
    height: auto;
    width: 100%;
  }
`;

const UsingCardContent = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const CtaButton = styled(S.CtaButton)`
  color: #024a88;
  &:hover {
    background: #e7f0fe;
  }
  &:active {
    background: #c2e2ff;
  }
`;

const SampleSection = styled(S.Section)`
  align-items: flex-start;
  padding: 24px 16px 40px 16px;
`;

const SampleTitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const SampleText = styled.div`
  color: #008aff;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const Sample = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
